var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material/styles';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { grey } from '@mui/material/colors';
/* eslint-disable import/prefer-default-export */
export var inputCustomization = {
    MuiInputBase: {
        styleOverrides: {
            root: {
                border: 'none',
            },
            input: {
                '&::placeholder': {
                    opacity: 0.7,
                    color: grey[500],
                },
            },
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            input: {
                padding: 0,
            },
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (__assign(__assign((_b = { padding: '8px 12px', color: theme.palette.text.primary, borderRadius: theme.shape.borderRadius, border: "1px solid ".concat(theme.palette.divider), backgroundColor: theme.palette.background.default, transition: 'border 120ms ease-in', '&:hover': {
                            borderColor: grey[400],
                        } }, _b["&.".concat(outlinedInputClasses.focused)] = {
                    outline: "3px solid ".concat(alpha(theme.palette.primary.light, 0.5)),
                    borderColor: theme.palette.primary.main,
                }, _b), theme.applyStyles('dark', {
                    '&:hover': {
                        borderColor: grey[500],
                    },
                })), { variants: [
                        {
                            props: {
                                size: 'small',
                            },
                            style: {
                                height: '2.25rem',
                            },
                        },
                        {
                            props: {
                                size: 'medium',
                            },
                            style: {
                                height: '2.5rem',
                            },
                        },
                    ] }));
            },
            notchedOutline: {
                border: 'none',
            },
        },
    },
    MuiInputAdornment: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return (__assign({ color: theme.palette.grey[500] }, theme.applyStyles('dark', {
                    color: theme.palette.grey[400],
                })));
            },
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return ({
                    typography: theme.typography.caption,
                    marginBottom: 8,
                });
            },
        },
    },
};
